import * as Sentry from "@sentry/react";

const dsn = import.meta.env.VITE_SENTRY_DSN;
if (dsn) {
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_SENTRY_RELEASE,
    tracePropagationTargets: [/^https:\/\/.*\.hts\.pro$/, /^https:\/\/harris-technology-services\.com$/, /^https:\/\/.*\.azurewebsites\.net$/],
    tracesSampleRate: import.meta.env.MODE === "production" ? 0.1 : 1.0,
    enableLogs: true,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      Sentry.replayIntegration(),
      Sentry.feedbackIntegration({
        autoInject: false,
        themeLight: {
          accentBackground: '#00b8eb',
          accentForeground: '#ffffff',
          background: '#1a1f2c',
          foreground: '#e7eaf0',
        },
        themeDark: {
          accentBackground: '#00b8eb',
          accentForeground: '#0a0d13',
          background: '#1a1f2c',
          foreground: '#e7eaf0',
        },
      }),
    ],
  });
}
